import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addCountry = createAsyncThunk('addCountry', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'master-country',
            data: {
                "country_name": data?.values?.countryName,
                "short_name": data?.values?.shortName,
                "description": data?.values?.description,
                // "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})